import { Validators } from '@angular/forms';
import { INPUT_TYPES_CONFIG } from '../products.config';

export const TRACTOR = {
  nickname: 'PRODUCTS.TRACTOR.nickname',
  properties: [
    {
      name: 'tractorMark', key: 'WTC_MARK', group: 'OBJECT_INFO',
      inputType: INPUT_TYPES_CONFIG.STRING,
      validator: [''],
    },
    {
      name: 'tractorModel', key: 'WTC_MODEL', group: 'OBJECT_INFO',
      inputType: INPUT_TYPES_CONFIG.STRING,
      validator: [''],
    },
    { name: 'vehicleRegistrationYear', key: 'REGISTRATION_YEAR', group: 'OBJECT_INFO',
      inputType: INPUT_TYPES_CONFIG.DATE,
      validator: ['', [
        Validators.required
      ]],
      settings: {
        dateView: 'multi-years'
      }
    },
    { name: 'vehicleLicenseNumber', key: 'LICENSE_NUMBER', group: 'OBJECT_INFO',
      pattern: /[a-zA-Z]{2}\d{5}/,
      inputType: INPUT_TYPES_CONFIG.STRING,
      validator: ['']
    },
    { name: 'calculatedClientAge', key: 'CLIENT_AGE', group: 'OBJECT_INFO' },
    // {
    //   name: 'tfaGroup', key: 'TFA_GROUP', group: 'OBJECT_INFO',
    //   inputType: INPUT_TYPES_CONFIG.STRING,
    //   validator: ['', [
    //     Validators.required
    //   ]],
    // },
    {
      name: 'tractorRegisteredAsAtv', key: 'TRACTOR_REGISTERED_AS_ATV', group: 'OBJECT_INFO',
      inputType: INPUT_TYPES_CONFIG.BOOLEAN,
      validator: ['', [
        Validators.required
      ]],
    },
    { name: 'tractorMarketValue', key: 'WTC_TRACTOR_MARKET_VALUE', group: 'INSURANCE_INFO',
      inputType: INPUT_TYPES_CONFIG.STRING,
      validator: ['', [
        Validators.required
      ]]
    },
    { name: 'deductible', key: 'DEDUCTIBLE', group: 'INSURANCE_INFO',
      inputType: INPUT_TYPES_CONFIG.SELECT_DATA_LIST,
      validator: ['', [
        Validators.required
      ]],
      settings: {
        list: [
          { key: 'PROPERTIES_FORM.SELECT_LIST.WTC_VOLUNTARY_EXCESS.5', value: 5000 },
          { key: 'PROPERTIES_FORM.SELECT_LIST.WTC_VOLUNTARY_EXCESS.75', value: 7500 },
          { key: 'PROPERTIES_FORM.SELECT_LIST.WTC_VOLUNTARY_EXCESS.10', value: 10000 },
          { key: 'PROPERTIES_FORM.SELECT_LIST.WTC_VOLUNTARY_EXCESS.15', value: 15000 },
          { key: 'PROPERTIES_FORM.SELECT_LIST.WTC_VOLUNTARY_EXCESS.20', value: 20000 },
          { key: 'PROPERTIES_FORM.SELECT_LIST.WTC_VOLUNTARY_EXCESS.25', value: 25000 },
          { key: 'PROPERTIES_FORM.SELECT_LIST.WTC_VOLUNTARY_EXCESS.30', value: 30000 },
          { key: 'PROPERTIES_FORM.SELECT_LIST.WTC_VOLUNTARY_EXCESS.50', value: 50000 },
        ]
      }
    },
    { name: 'zipCode', key: 'OBJECT_ZIP', group: 'INSURANCE_INFO',
      inputType: INPUT_TYPES_CONFIG.TEL,
      validator: ['', [
        Validators.required,
        Validators.pattern('[0-9]{4}$')
      ]],
      customProductTypeConfig: {
        TRAILER: {
          key: 'OBJECT_ZIP_INVALID'
        }
      }
    },
    { name: 'productPackage', key: 'PRODUCT_PACKAGE_WTC', group: 'INSURANCE_INFO',
      inputType: INPUT_TYPES_CONFIG.SELECT_DATA_LIST,
      validator: ['', [
        Validators.required
      ]],
      isDriverAndPassengerCheck: true,
      settings: {
        list: [
          { key: 'PROPERTIES_FORM.SELECT_LIST.PRODUCT_PACKAGE.ANSVAR', value: 'ANSVAR' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.PRODUCT_PACKAGE.DELKASKO', value: 'DELKASKO' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.PRODUCT_PACKAGE.KASKO', value: 'KASKO' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.PRODUCT_PACKAGE.BRANN_TYVERI', value: 'FIRE_AND_THEFT_STANDALONE' }
        ]
      }
    },
    { name: 'vehicleDriverAccident', key: 'VEHICLE_DRIVER_ACCIDENT', group: 'INSURANCE_INFO',
      inputType: INPUT_TYPES_CONFIG.BOOLEAN,
      validator: ['', [
        Validators.required
      ]]
    },
    { name: 'tifGroup', key: 'TFA_ANNUAL_FEE_GROUP', group: 'INSURANCE_INFO',
      inputType: INPUT_TYPES_CONFIG.SELECT_DATA_LIST,
      isHugeSelectContainer: true,
      validator: ['', [
        Validators.required
      ]],
      settings: {
        list: [
          { key: 'PROPERTIES_FORM.SELECT_LIST.TFI_GROUP.GROUP_000', value: 'GROUP_000' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.TFI_GROUP.GROUP_100', value: 'GROUP_100' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.TFI_GROUP.GROUP_110', value: 'GROUP_110' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.TFI_GROUP.GROUP_200', value: 'GROUP_200' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.TFI_GROUP.GROUP_300', value: 'GROUP_300' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.TFI_GROUP.GROUP_400', value: 'GROUP_400' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.TFI_GROUP.GROUP_900', value: 'GROUP_900' }
        ]
      }
    },
    { name: 'productSumInsured', key: 'SUM_INSURED', group: 'INSURANCE_INFO' },
    { name: 'vehicleYoungDriver', key: 'YOUNG_DRIVER', group: 'INSURANCE_INFO' },
  ],
  icon:'tractor'
};
